var map = {
	"./arrow.svg": 9627,
	"./arrow_s2.svg": 7694,
	"./circle.svg": 4095,
	"./circle_s2.svg": 6679,
	"./dotted_line.svg": 5229,
	"./dotted_line_s2.svg": 7644,
	"./free.svg": 5666,
	"./free_s2.svg": 9179,
	"./hollow.svg": 5312,
	"./hollow_out.svg": 7947,
	"./hollow_out_s2.svg": 1977,
	"./hollow_s2.svg": 5899,
	"./horizon_line.svg": 9146,
	"./horizon_line_s2.svg": 4458,
	"./line_full_up.svg": 6959,
	"./line_full_up_s2.svg": 4423,
	"./polygon.svg": 6525,
	"./polygon_s2.svg": 2820,
	"./retangle.svg": 8570,
	"./retangle_s2.svg": 1571,
	"./shape_full_up.svg": 1688,
	"./shape_full_up_s2.svg": 2721,
	"./solid.svg": 7061,
	"./solid_s2.svg": 8371,
	"./star.svg": 2968,
	"./star_s2.svg": 4248,
	"./straight_line.svg": 5135,
	"./straight_line_s2.svg": 6564,
	"./triangle.svg": 484,
	"./triangle_s2.svg": 9432,
	"./vertical_line.svg": 8133,
	"./vertical_line_s2.svg": 8908,
	"./width_10.svg": 5763,
	"./width_10_s2.svg": 9139,
	"./width_15.svg": 6906,
	"./width_15_s2.svg": 9039,
	"./width_2.svg": 6967,
	"./width_20.svg": 8848,
	"./width_20_s2.svg": 7413,
	"./width_2_s2.svg": 4041,
	"./width_3.svg": 9761,
	"./width_30.svg": 5925,
	"./width_30_s2.svg": 7497,
	"./width_35.svg": 4750,
	"./width_35_s2.svg": 7415,
	"./width_3_s2.svg": 9018,
	"./width_5.svg": 4901,
	"./width_5_s2.svg": 3347
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6097;